import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function AboutMissionPreview() {
  const values = ["זמינות מיידית בבית החולים מאיר", "צוות מטפלים מוסמך ומנוסה", "ליווי אישי ורגיש לאורך כל האשפוז"];
  return <section data-section-id="253660" id="מיקומים-וביתנות-בכפר-סבא" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col justify-center order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="h-px w-8 bg-primary"></span>
              <span className="text-primary font-default font-semibold tracking-wider uppercase text-sm">
                שירותי סיעוד בכפר סבא
              </span>
            </div>
            
            <h2 className="text-foreground font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              מעטפת טיפולית מקצועית <br className="hidden md:block" />
              במרכז הרפואי מאיר.
            </h2>
            
            <p className="text-muted-foreground font-default text-lg leading-relaxed mb-8 max-w-xl">
              אנו מספקים שירותי השגחה וסיעוד פרטיים בבית החולים מאיר בכפר סבא, מתוך הבנה שרגעים אלו דורשים רגישות ומקצועיות ללא פשרות. הצוות שלנו ערוך להעניק סיוע פיזי ותמיכה רגשית למטופל ולבני משפחתו, תוך הקפדה על סטנדרטים גבוהים של טיפול וזמינות מסביב לשעון.
            </p>

            <ul className="space-y-4 mb-10">
              {values.map((value, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-secondary shrink-0 mt-0.5" />
                  <span className="text-foreground font-default font-medium">{value}</span>
                </li>)}
            </ul>

            <div>
              <Button variant="secondary" size="lg" className="font-default text-lg px-8 py-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" asChild>
                <Link to="/NursingCareProviderInKfarSabaWithinFiveHoursPage">למידע נוסף על השירות</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 relative">
            <div className="absolute -inset-4 bg-accent/20 rounded-lg transform rotate-3 scale-105 -z-10 hidden md:block"></div>
            <div className="rounded-lg overflow-hidden shadow-2xl border border-border/50 bg-card">
              <AspectRatio ratio={4 / 5} className="w-full h-full">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/meir_hospital_care.png" alt="צוות סיעודי מקצועי בבית החולים מאיר כפר סבא" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="lazy" />
              </AspectRatio>
            </div>
          </div>

        </div>
      </div>
    </section>;
}